import React from 'react';
import ytIcon from '../../img/logo.jpg';
import { Link } from 'react-router-dom';
import { Navbar, Nav } from 'react-bootstrap';
import '../../css/Header/Header.scss';
import styled from 'styled-components';


// メディアクエリを使用して表示しようかと思ったがなかなかうまく動作しなかった
const Menu = styled.div`
    display: block !important;
    position: fixed;
    top: 0;
    right: 0;
    width: 0;
    height: 100%;
    background-color: rgb(10, 66, 117);
    transition: width .2s;
`;



// モバイル用のハンバガーメニューとPCサイズのナビバーを作成
const NavbarsAndHanbargar = () => {
    const url ='/yotsutaninet/';
    function onClickHandleA () {
        window.location.replace("https://www.google.com/")
    }
    return (
        <Nav className="mr-auto sp-Nav WidMax" style={{width: '100%'}}>
        <Link  className="Hover nav-scope paddingWhitespace" to={url + 'Explanation'} >
            <Nav>はりまやYT教室について</Nav>
        </Link>

        {/* <Link  to={url + 'Course'} className="nav-scope">
            <Nav>コース/時間割</Nav>
        </Link> */}
        <a href="https://www.tosajuku.com/ytWinterTime.pdf" className='nav-scope'>
            <Nav>コース/時間割</Nav>
        </a>

        <Link  to={url + 'Success'} className="nav-scope">
            <Nav>合格実績</Nav>
        </Link>
        
        <Link  to={url + 'Join#str'}className="nav-scope">
            <Nav>入塾の流れ</Nav>
        </Link>

        <Link  to={url + 'StudyFlow'} className="nav-scope">
            <Nav>学習の流れ</Nav>
        </Link>

        <Link  to={url + 'Information'} className="nav-scope">
            <Nav>YT情報</Nav>
        </Link>

        {/* <a  href="https://tosajuku.info/tsjk_webpage/student-login/login.php" className="nav-scope">
            <Nav>塾生専用ページ</Nav>
        </a> */}
     

    </Nav>
    );
}

const Navbars = () => {
    const url ='/yotsutaninet/';
    return (
        <div className="fixed-top nav-mainColor">
            {/* ナビバー */}
            <Navbar collapseOnSelect expand="lg"  variant="dark">
              <Link to={url} >
                <Navbar.Brand >
                        <img
                            src={ytIcon}
                            alt="React Bootstrap logo"
                            style={{width: '70%'}}
                        />
                    </Navbar.Brand>
              </Link>
         
                {/* <Navbar.Toggle aria-controls="responsive-navbar-nav"  style={{backgroundImage:'linear-gradient(0deg, #990820 0%, #ba0020 100%)'}}/> */}
                {/* モバイルだけ表示するようにする */}
                <Menu className="menu">
                    <button class="menu__button">
                        <span class="menu__lineTop"></span>
                        <span class="menu__lineMiddle"></span>
                        <span class="menu__lineBottom"></span>
                    </button>
                    <div>
                       <NavbarsAndHanbargar />
                    </div>
                </Menu>
               
                <Navbar.Collapse id="responsive-navbar-nav">
                    <NavbarsAndHanbargar />
                </Navbar.Collapse>
            </Navbar >
        </div>
       
    );
  };

export default Navbars;
